export default "/assets/787ecc9bc76e954a.gif"